import global from '../global'

export default ({
	login (obj) {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/user/login',
				data: JSON.stringify(obj),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	},
	signUp (obj) {
		return new Promise((resolve, reject) => {
			global.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/app/user/register?lang=fr&platform=ios&app_version=1.1.10',
				data: JSON.stringify(obj),
				success (response) {
					resolve(response)
				},
				error (error) {
					reject(error)
				}
			}, true)
		})
	}
})



// WEBPACK FOOTER //
// ./src/controllers/Users.js